import React, { Component } from 'react';
import axios from 'axios';
import { Link, Redirect } from 'react-router-dom';

const verificationDelays = [2000, 3000, 5000];
const maxAutomaticRetries = 2;

class Verifypaypage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            redirectTo: null,
            checking: false,
            pending: false,
            errorMessage: ''
        };
        this.isUnmounted = false;
    }

    componentDidMount() {
        const query = new URLSearchParams(this.props.location.search);
        this.verificationToken = query.get('token');

        if (!this.verificationToken) {
            this.redirectToCheckout('Bestelling niet gevonden.');
            return;
        }

        this.schedulePaymentCheck(0);
    }

    componentWillUnmount() {
        this.isUnmounted = true;
        clearTimeout(this.verificationTimeout);
    }

    schedulePaymentCheck = (retryCount) => {
        this.setState({
            checking: true,
            pending: false,
            errorMessage: retryCount
                ? 'Uw betaling wordt gecontroleerd.'
                : 'Uw betaling wordt gecontroleerd.'
        });
        this.verificationTimeout = setTimeout(
            () => this.checkPaymentStatus(retryCount),
            verificationDelays[retryCount]
        );
    };

    checkPaymentStatus = (retryCount) => {
        axios.get('/api/verify-payment-status/', {
            params: { token: this.verificationToken },
            timeout: 10000
        })
            .then((response) => {
                if (this.isUnmounted) {
                    return;
                }

                if (response.data.paid) {
                    this.setState({
                        redirectTo: {
                            pathname: '/online-afhalen/success',
                            state: {
                                customer_name: response.data.customer_name,
                                customer_email: response.data.customer_email,
                                customer_phone: response.data.customer_phone,
                                tijdstip: response.data.tijdstip,
                                final_total_cost: response.data.final_total_cost,
                                cartItems: response.data.cartItems,
                                orderID: response.data.orderID
                            }
                        }
                    });
                } else if (response.data.pending) {
                    this.retryOrShowPending(retryCount, response.data.errormsg);
                } else {
                    this.redirectToCheckout(response.data.errormsg || 'Betaling mislukt.');
                }
            })
            .catch((error) => {
                if (this.isUnmounted) {
                    return;
                }

                const errorMessage = error.response && error.response.data && error.response.data.errormsg
                    ? error.response.data.errormsg
                    : 'De betalingsstatus kon niet worden gecontroleerd.';
                this.retryOrShowPending(retryCount, errorMessage);
            });
    };

    retryOrShowPending = (retryCount, errorMessage) => {
        if (retryCount < maxAutomaticRetries) {
            this.schedulePaymentCheck(retryCount + 1);
            return;
        }

        this.setState({
            checking: false,
            pending: true,
            errorMessage: `${errorMessage} U kunt handmatig opnieuw controleren.`
        });
    };

    checkAgain = () => {
        this.schedulePaymentCheck(0);
    };

    redirectToCheckout = (errorMessage) => {
        this.setState({
            checking: false,
            redirectTo: {
                pathname: '/online-afhalen/checkout',
                state: { error_message: errorMessage }
            }
        });
    };

    render() {
        if (this.state.redirectTo) {
            return <Redirect to={this.state.redirectTo} />;
        }

        return (
            <div className="container text-center my-5">
                {this.state.checking ? (
                    <div>
                        <h3>Betaling controleren</h3>
                        <p>{this.state.errorMessage}</p>
                        <div className="spinner-border text-primary" role="status">
                            <span className="sr-only">Bezig met controleren...</span>
                        </div>
                    </div>
                ) : this.state.pending ? (
                    <div>
                        <h3>Betaling nog niet bevestigd</h3>
                        <p>{this.state.errorMessage}</p>
                        <button className="btn btn-primary" onClick={this.checkAgain}>
                            Opnieuw controleren
                        </button>
                        {' '}
                        <Link
                            className="btn btn-link"
                            to={{
                                pathname: '/online-afhalen/checkout',
                                state: { error_message: 'De betaling is nog niet bevestigd. U kunt verdergaan met de bestaande betaling.' }
                            }}
                        >
                            Terug naar betalen
                        </Link>
                    </div>
                ) : null}
            </div>
        );
    }
}

export default Verifypaypage;